import Loadable from './Loadable';
export default Loadable;
